<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-input v-model="query" placeholder="请输入查询条件" class="sx-input" size="small"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search" size="small">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" plain @click="handleAdd" size="small">新增</el-button>
      </el-form-item>
    </el-form>


    <el-table v-loading="loading" :data="tableData" border>

      <el-table-column prop="id" label="编号" width="60" v-if="isShow" header-align="center" align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="roleCode" label="角色编码" width="140" header-align="center" align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="roleName" label="角色名称" width="140" header-align="center" align="center"
        show-overflow-tooltip>
      </el-table-column>

      <el-table-column label="操作" header-align="center" align="center" width="200px">
        <template slot-scope="scope">
          <el-button size="mini" plain @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" plain type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination :page-size="pageSize" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="currentPage" background layout="sizes, prev, pager, next" :total="totalRows">
    </el-pagination>

    <el-dialog :close-on-click-modal="false" v-dialogDrag title="操作" :visible.sync="dialogVisible" width="500px">
      <el-form :model="sysRole" label-position="right" label-width="80px">
        <!-- <el-form-item label="编码">
					<el-input v-model="sysRole.id" placeholder=""></el-input>
				</el-form-item> -->
        <el-form-item label="角色编码">
          <el-input v-model="sysRole.roleCode" size="small"></el-input>
        </el-form-item>
        <el-form-item label="角色名称">
          <el-input v-model="sysRole.roleName" size="small"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button type="success" size="small" @click="handleSave">保存</el-button>
        <el-button type="danger" size="small" @click="handleCancelSave">取消</el-button>
      </span>

    </el-dialog>


  </div>
</template>
<script>
  import axios from '@/axios';
  export default {
    data() {
      return {
        isShow: false,
        tableData: [],
        tableProperty: [],
        currentPage: 1,
        totalRows: 0,
        pageSizes: [10, 20, 30, 40],
        pageSize: 10,
        query: '',
        sysRole: {
          id: '',
          roleCode: '',
          roleCode: '',
          roleName: '',
          roleName: '',
        },
        loading: true,
        dialogVisible: false,
      }
    },
    methods: {
      //查询table数据
      getTableData() {
        var url = 'framework/SysRole/query.do'
        var param = {
          page: this.currentPage,
          rows: this.pageSize,
          roleName: this.query
        }
        axios.get(url, param).then(response => {
          if (response.data.code == '0') {
            this.tableData = response.data.data.list
            this.totalRows = response.data.data.total
          } else {
            this.$message({
              type: 'error',
              message: '操作失败!' + response.data.msg
            });
          }
          this.loading = false
        });
      },
      //查询table列
      getTableProperty() {
        //console.log("获取table数据getTableData")
        var url = 'CodeMachine/queryTableProperty.do'
        var param = {
          businessName: 'SYS_ROLE'
        }
        axios.get(url, param).then(response => {
          this.tableProperty = response.data.data
        });
      },

      // 修改每页行数
      handleSizeChange(val) {
        this.pageSize = val
        this.getTableData()
      },
      // 修改当前页事件
      handleCurrentChange(val) {
        this.currentPage = val
        this.getTableData()
      },
      //新增按钮事件
      handleAdd() {
        this.dialogVisible = true
        this.sysRole = {
          id: '',
          roleCode: '',
          roleCode: '',
          roleName: '',
          roleName: '',
        }
      },
      // 编辑按钮事件
      handleEdit(row) {
        this.dialogVisible = true
        this.sysRole = row

      },
      // 删除按钮事件
      handleDelete(id) {
        this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var url = 'framework/SysRole/remove.do'
          var param = {
            id: id
          }
          axios.post(url, param).then(response => {
            if (response.data.code == '0') {
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
              this.getTableData()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!' + response.data.msg
              });
            }

          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      //保存取消按钮事件   关闭编辑对话框
      handleCancelSave(row) {
        this.dialogVisible = false
      },
      //保存按钮事件
      handleSave(row) {
        var url = 'framework/SysRole/save.do'
        var json = JSON.stringify(this.sysRole)
        var param = {
          json: json
        }
        axios.post(url, param).then(response => {
          if (response.data.code == '0') {
            this.$message({
              type: 'success',
              message: '操作成功!',
            });
            this.getTableData()
            this.dialogVisible = false
          } else {
            this.$message({
              type: 'error',
              message: '操作失败!' + response.data.msg
            });
          }
        });
      },

      // 查询按钮事件
      search() {
        this.getTableData()
      }
    },
    mounted() {
      this.getTableData()
      //this.getTableProperty()
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/system/role.vue